document.addEventListener('DOMContentLoaded', function() {
  const productTable = document.getElementById('product-table');
  if (!productTable) return;

  const tbody = productTable.querySelector('tbody');
  const rows = Array.from(tbody.querySelectorAll('.product-row'));

  let currentTypeFilter = 'all';
  let cartItems = {};
  let currentSort = { column: null, direction: null };

  function calculateHeaderHeight() {
    const siteHeader = document.querySelector('.site-header');
    if (siteHeader) {
      const height = siteHeader.offsetHeight;
      document.documentElement.style.setProperty('--site-header-height', height + 'px');
    }
  }

  calculateHeaderHeight();

  window.addEventListener('resize', function() {
    calculateHeaderHeight();
  });

  const urlParams = new URLSearchParams(window.location.search);
  const filterParam = urlParams.get('filter');
  if (filterParam && ['all', 'digital', 'physical'].includes(filterParam)) {
    currentTypeFilter = filterParam;
  }

  const filterButtons = document.querySelectorAll('.filter-btn[data-type="type"]');

  filterButtons.forEach(btn => {
    if (btn.dataset.filter === currentTypeFilter) {
      btn.classList.add('active');
    }

    btn.addEventListener('click', function() {
      filterButtons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      currentTypeFilter = this.dataset.filter;

      const url = new URL(window.location);
      if (currentTypeFilter === 'all') {
        url.searchParams.delete('filter');
      } else {
        url.searchParams.set('filter', currentTypeFilter);
      }
      window.history.pushState({}, '', url);

      applyFilters();
    });
  });

  function applyFilters() {
    let visibleCount = 0;

    rows.forEach(row => {
      const type = row.dataset.type;
      let showRow = true;

      if (currentTypeFilter !== 'all' && type !== currentTypeFilter) {
        showRow = false;
      }

      if (showRow) {
        row.classList.remove('hidden');
        visibleCount++;
      } else {
        row.classList.add('hidden');
      }
    });

    showEmptyState(visibleCount === 0);
  }

  function showEmptyState(show) {
    let emptyState = tbody.querySelector('.empty-state');

    if (show && !emptyState) {
      emptyState = document.createElement('tr');
      emptyState.className = 'empty-state';
      emptyState.innerHTML = '<td colspan="8" style="text-align: center; padding: 40px; color: #666;">No products match the current filter.</td>';
      tbody.appendChild(emptyState);
    } else if (!show && emptyState) {
      emptyState.remove();
    }
  }

  const sortableHeaders = document.querySelectorAll('.product-table th.sortable');

  sortableHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const column = this.dataset.column;

      if (currentSort.column === column) {
        if (currentSort.direction === 'asc') {
          currentSort.direction = 'desc';
        } else if (currentSort.direction === 'desc') {
          currentSort.direction = 'asc';
        }
      } else {
        currentSort.column = column;
        currentSort.direction = 'asc';
      }

      sortableHeaders.forEach(h => {
        h.classList.remove('sort-asc', 'sort-desc');
      });

      this.classList.add('sort-' + currentSort.direction);

      sortTable(column, currentSort.direction);
    });
  });

  function sortTable(column, direction) {
    const visibleRows = rows.filter(row => !row.classList.contains('hidden'));

    visibleRows.sort((a, b) => {
      let aVal, bVal;

      switch(column) {
        case 'title':
          aVal = a.dataset.title.toLowerCase();
          bVal = b.dataset.title.toLowerCase();
          break;
        case 'description':
          aVal = a.dataset.description.toLowerCase();
          bVal = b.dataset.description.toLowerCase();
          break;
        case 'collection':
          aVal = a.dataset.collection.toLowerCase();
          bVal = b.dataset.collection.toLowerCase();
          break;
        case 'variant':
          aVal = a.dataset.variantLabel.toLowerCase();
          bVal = b.dataset.variantLabel.toLowerCase();
          break;
        case 'inventory':
          aVal = parseInt(a.dataset.inventory) || 0;
          bVal = parseInt(b.dataset.inventory) || 0;
          break;
        case 'tags':
          aVal = a.dataset.tags.toLowerCase();
          bVal = b.dataset.tags.toLowerCase();
          break;
        case 'price':
          aVal = parseFloat(a.dataset.price) || 0;
          bVal = parseFloat(b.dataset.price) || 0;
          break;
        case 'action':
          aVal = a.dataset.inCart === 'true' ? 1 : 0;
          bVal = b.dataset.inCart === 'true' ? 1 : 0;
          break;
        default:
          return 0;
      }

      if (typeof aVal === 'string') {
        if (direction === 'asc') {
          return aVal.localeCompare(bVal);
        } else {
          return bVal.localeCompare(aVal);
        }
      } else {
        if (direction === 'asc') {
          return aVal - bVal;
        } else {
          return bVal - aVal;
        }
      }
    });

    visibleRows.forEach(row => {
      tbody.appendChild(row);
    });
  }

  function fetchCart() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        cartItems = {};
        cart.items.forEach(item => {
          cartItems[item.variant_id] = item;
        });
        updateAllButtonStates();
        updateCartCount(cart.item_count);
        return cart;
      })
      .catch(err => console.error('Error fetching cart:', err));
  }

  function updateAllButtonStates() {
    rows.forEach(row => {
      const variantId = row.dataset.variantId;
      const buyBtn = row.querySelector('.buy-btn');

      if (buyBtn && variantId) {
        if (cartItems[variantId]) {
          buyBtn.textContent = 'Remove';
          buyBtn.classList.add('in-cart');
          row.dataset.inCart = 'true';
        } else {
          buyBtn.textContent = 'Buy';
          buyBtn.classList.remove('in-cart');
          row.dataset.inCart = 'false';
        }
      }
    });
  }

  function updateCartCount(count) {
    const cartCount = document.getElementById('cart-count');
    if (cartCount) {
      cartCount.textContent = count || 0;
    }
  }

  const buyButtons = document.querySelectorAll('.buy-btn');
  buyButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.disabled) return;

      const variantId = this.dataset.variantId;
      const row = this.closest('.product-row');

      if (!variantId) return;

      const isInCart = cartItems[variantId];

      if (isInCart) {
        this.textContent = 'Removing...';
        this.disabled = true;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 })
        })
        .then(response => response.json())
        .then(() => {
          fetchCart();
        })
        .catch(err => {
          console.error('Error removing from cart:', err);
          alert('Unable to remove from cart. Please try again.');
          this.disabled = false;
          this.textContent = 'Remove';
        });
      } else {
        this.textContent = 'Adding...';
        this.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(response => response.json())
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch(err => {
          console.error('Error adding to cart:', err);
          alert('Unable to add to cart. Please try again.');
          this.textContent = 'Buy';
          this.disabled = false;
        });
      }
    });
  });

  const addButtons = document.querySelectorAll('.add-btn');
  addButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.disabled) return;

      const variantId = this.dataset.variantId;
      if (!variantId) return;

      this.textContent = '...';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(response => response.json())
      .then(() => {
        this.textContent = '✓';
        setTimeout(() => {
          this.textContent = '+';
          this.disabled = false;
        }, 1000);
        fetchCart();
      })
      .catch(err => {
        console.error('Error adding to cart:', err);
        alert('Unable to add to cart. Please try again.');
        this.textContent = '+';
        this.disabled = false;
      });
    });
  });

  const variantSelects = document.querySelectorAll('.variant-select');
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const row = this.closest('.product-row');
      const variantId = this.value;
      const selectedOption = this.options[this.selectedIndex];
      const variantLabel = selectedOption.text;

      row.dataset.variantId = variantId;
      row.dataset.variantLabel = variantLabel;

      const buyBtn = row.querySelector('.buy-btn');
      const addBtn = row.querySelector('.add-btn');

      if (buyBtn) {
        buyBtn.dataset.variantId = variantId;
        if (cartItems[variantId]) {
          buyBtn.textContent = 'Remove';
          buyBtn.classList.add('in-cart');
          row.dataset.inCart = 'true';
        } else {
          buyBtn.textContent = 'Buy';
          buyBtn.classList.remove('in-cart');
          row.dataset.inCart = 'false';
        }
      }

      if (addBtn) {
        addBtn.dataset.variantId = variantId;
      }
    });
  });

  const createBtn = document.getElementById('create-btn');
  const createDropdown = document.getElementById('create-dropdown');

  if (createBtn && createDropdown) {
    createBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      createDropdown.classList.toggle('show');
    });

    document.addEventListener('click', function(e) {
      if (!createBtn.contains(e.target) && !createDropdown.contains(e.target)) {
        createDropdown.classList.remove('show');
      }
    });
  }

  let plyrPlayer = null;
  let currentPlayingBtn = null;

  function initAudioPlayer() {
    const audioElement = document.getElementById('audio-element');
    if (audioElement && typeof Plyr !== 'undefined') {
      plyrPlayer = new Plyr(audioElement, {
        controls: ['play', 'progress', 'current-time', 'mute', 'volume']
      });

      plyrPlayer.on('ended', function() {
        if (currentPlayingBtn) {
          currentPlayingBtn.classList.remove('playing');
          currentPlayingBtn.textContent = '▶︎';
          currentPlayingBtn = null;
        }
      });

      plyrPlayer.on('pause', function() {
        if (currentPlayingBtn) {
          currentPlayingBtn.classList.remove('playing');
          currentPlayingBtn.textContent = '▶︎';
        }
      });

      plyrPlayer.on('play', function() {
        if (currentPlayingBtn) {
          currentPlayingBtn.classList.add('playing');
          currentPlayingBtn.textContent = '⏸';
        }
      });
    }
  }

  const playButtons = document.querySelectorAll('.play-btn');
  playButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const audioUrl = this.dataset.audioUrl;
      const trackTitle = this.dataset.trackTitle;
      const trackArtist = this.dataset.trackArtist;

      if (!audioUrl || !plyrPlayer) return;

      const globalPlayer = document.getElementById('global-audio-player');
      const titleElement = document.getElementById('audio-track-title');
      const artistElement = document.getElementById('audio-track-artist');

      if (currentPlayingBtn === this) {
        if (plyrPlayer.playing) {
          plyrPlayer.pause();
        } else {
          plyrPlayer.play();
        }
        return;
      }

      if (currentPlayingBtn) {
        currentPlayingBtn.classList.remove('playing');
        currentPlayingBtn.textContent = '▶︎';
      }

      currentPlayingBtn = this;

      plyrPlayer.source = {
        type: 'audio',
        sources: [{ src: audioUrl }]
      };

      titleElement.textContent = trackTitle || 'Unknown Track';
      artistElement.textContent = trackArtist || '';

      globalPlayer.classList.add('visible');

      plyrPlayer.play();
    });
  });

  if (typeof Plyr !== 'undefined') {
    initAudioPlayer();
  }

  document.addEventListener('play-audio', function(e) {
    const { audioUrl, trackTitle, trackArtist } = e.detail;

    if (!audioUrl || !plyrPlayer) return;

    const globalPlayer = document.getElementById('global-audio-player');
    const titleElement = document.getElementById('audio-track-title');
    const artistElement = document.getElementById('audio-track-artist');

    if (currentPlayingBtn) {
      currentPlayingBtn.classList.remove('playing');
      currentPlayingBtn.textContent = '▶︎';
      currentPlayingBtn = null;
    }

    plyrPlayer.source = {
      type: 'audio',
      sources: [{ src: audioUrl }]
    };

    titleElement.textContent = trackTitle || 'Unknown Track';
    artistElement.textContent = trackArtist || '';

    globalPlayer.classList.add('visible');

    plyrPlayer.play();
  });

  applyFilters();

  fetchCart();
});

// Blog Article Filtering
document.addEventListener('DOMContentLoaded', function() {
  const isBlogPage = document.body.classList.contains('template-blog') ||
                     document.body.classList.contains('template-article');

  if (!isBlogPage) return;

  const productTable = document.getElementById('product-table');
  if (!productTable) return;

  const tbody = productTable.querySelector('tbody');
  const rows = Array.from(tbody.querySelectorAll('.article-row'));

  if (rows.length === 0) return;

  let currentTypeFilter = 'all';

  const urlParams = new URLSearchParams(window.location.search);
  const filterParam = urlParams.get('filter');
  if (filterParam && ['all', 'digital', 'physical'].includes(filterParam)) {
    currentTypeFilter = filterParam;
  }

  const filterButtons = document.querySelectorAll('.filter-btn[data-context="blog"]');

  filterButtons.forEach(btn => {
    if (btn.dataset.filter === currentTypeFilter) {
      btn.classList.add('active');
    }

    btn.addEventListener('click', function() {
      filterButtons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      currentTypeFilter = this.dataset.filter;

      const url = new URL(window.location);
      if (currentTypeFilter === 'all') {
        url.searchParams.delete('filter');
      } else {
        url.searchParams.set('filter', currentTypeFilter);
      }
      window.history.pushState({}, '', url);

      applyBlogFilters();
    });
  });

  function applyBlogFilters() {
    let visibleCount = 0;

    rows.forEach(row => {
      const tags = row.dataset.tags.toLowerCase();
      let showRow = false;

      if (currentTypeFilter === 'all') {
        showRow = true;
      } else if (currentTypeFilter === 'digital' && tags.includes('digital')) {
        showRow = true;
      } else if (currentTypeFilter === 'physical' && tags.includes('physical')) {
        showRow = true;
      }

      if (showRow) {
        row.classList.remove('hidden');
        visibleCount++;
      } else {
        row.classList.add('hidden');
      }
    });

    showBlogEmptyState(visibleCount === 0);
  }

  function showBlogEmptyState(show) {
    let emptyState = tbody.querySelector('.empty-state');

    if (show && !emptyState) {
      emptyState = document.createElement('tr');
      emptyState.className = 'empty-state';
      emptyState.innerHTML = '<td colspan="8" style="text-align: center; padding: 40px; color: #666;">No articles match the current filter.</td>';
      tbody.appendChild(emptyState);
    } else if (!show && emptyState) {
      emptyState.remove();
    }
  }

  applyBlogFilters();
});
